module.exports = __webpack_public_path__ + "img/certZhang.7a50c891.png";